<template>
  <CardFrame :bgColor="'blue'" hasDropShadow>
    <CardLink
      class="h-full"
      :href="data.video.videoLink ? data.video.videoLink : getUrl(data.slug)">
      <CardContainer :size="'small'">
        <CardMediaContainer>
          <CardVideoThumbnail :image="data.image" />
        </CardMediaContainer>
        <CardHeaderContainer>
          <CardMeta>{{ data.video ? data.video.videoTime : "" }}</CardMeta>
          <Title
            class="text-pretty text-left"
            :class="{ 'external-link': data.video.videoLink }"
            :headingTag="'h3'"
            :style="'h3'">
            {{ data.title }}
          </Title>
        </CardHeaderContainer>
      </CardContainer>
    </CardLink>
  </CardFrame>
</template>

<script>
import { buildUrl } from "../../../compostables/useHelpers";

import CardBodyContainer from "../../Atoms/Cards/CardBodyContainer.vue";
import CardBody from "../../Atoms/Cards/CardBody.vue";
import CardContainer from "../../Atoms/Cards/CardContainer.vue";
import CardFrame from "../../Atoms/Cards/CardFrame.vue";
import CardHeaderContainer from "../../Atoms/Cards/CardHeaderContainer.vue";
import CardLink from "../../Atoms/Cards/CardLink.vue";
import CardMediaContainer from "../../Atoms/Cards/CardMediaContainer.vue";
import CardMeta from "../../Atoms/Cards/CardMeta.vue";
import CardVideoThumbnail from "../../Atoms/Cards/CardVideoThumbnail.vue";
import Title from "../../Atoms/Heading.vue";
import Icon from "../../Svgs/Icons/ExternalLink.vue";

export default {
  components: {
    CardBodyContainer,
    CardBody,
    CardContainer,
    CardFrame,
    CardHeaderContainer,
    CardLink,
    CardMediaContainer,
    CardMeta,
    CardVideoThumbnail,
    Title,
    Icon,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  setup(props) {
    const getUrl = (slug) => {
      return buildUrl(slug, "resources/webinars");
    };

    return {
      getUrl,
    };
  },
};
</script>
